import React, {Component} from 'react';
import {connect} from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';

import {setSellType, setBienType, setReference, setCity, setChambresRange, setChambresValues, setSurfaceRange, setSurfaceValues, setPrixRange, setPrixValues } from '../../store/filtersActions';
import {setFilteredEstate} from '../../store/estateActions';

import Filters from '../filters/filtersComponent';
import EstateList from '../estate/estateList';
import FavBannerSlider from './favBannerSlider';
import ErrorPage from '../errorPage';

class EstateContainer extends Component {

    render(){
        if (this.props.estatesState.isLoading) {
            return (
                <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                    <CircularProgress className="loaderColor"/>
                </div>
            )
        }
        if(this.props.estatesState.error) {
            return <ErrorPage />
        }
        return (
            <div className="properties-section-body content-area">
                <FavBannerSlider estates={this.props.estatesState.estates}/>
                <div className="container">
                    <div className="row">
                        <EstateList estates={this.props.estatesState.filteredEstates} />
                        <Filters actions={this.props.actions} filters={this.props.filters} estates={this.props.estatesState.estates} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        estatesState: state.estates,
        filters: state.filters
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: {
            setSellType: (data) => dispatch(setSellType(data)),
            setBienType: (data) => dispatch(setBienType(data)),
            setReference: (data) => dispatch(setReference(data)),
            setCity: (data) => dispatch(setCity(data)),
            setChambresRange: (data) => dispatch(setChambresRange(data)),
            setChambresValues: (data) => dispatch(setChambresValues(data)),
            setSurfaceRange: (data) => dispatch(setSurfaceRange(data)),
            setSurfaceValues: (data) => dispatch(setSurfaceValues(data)),
            setPrixRange: (data) => dispatch(setPrixRange(data)),
            setPrixValues: (data) => dispatch(setPrixValues(data)),
            setFilteredEstate: (data) => dispatch(setFilteredEstate(data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EstateContainer);
